export default __webpack_public_path__ + "static/media/img-profile-tech-sehun2x.2b39aa32.png";